import { ICeilingGridItem } from "@multiconsult-group/multiplacer-core";
import { createSelector } from "@reduxjs/toolkit";
import { selectActivePartialMcbimSpace } from "../../McBim/mcbimSelectors";
import { calculateCeilingIntersection } from "@multiconsult-group/multiplacer-core";
import { selectHttpSingleRoomFull } from "../../Room/httpRoomSelectors";

export const selectActiveCeilingGrids = createSelector(
  [selectActivePartialMcbimSpace],
  (activeSpace) => activeSpace?.ceilingGrids ?? ([] as ICeilingGridItem[])
);

export const selectMlCeilingPredicionArgs = createSelector(
  [selectHttpSingleRoomFull, selectActivePartialMcbimSpace],
  (singleRoom, activeSpace) => {
    if (!singleRoom || !activeSpace) return null;

    const ceilingGridIntersection = calculateCeilingIntersection(
      activeSpace.ceilingGrids ?? ([] as ICeilingGridItem[])
    );
    return {
      roomNr: singleRoom.roomNumber,
      roomName: singleRoom.roomName ?? activeSpace.longName,
      projectNo: singleRoom.projectNo,
      ceilingGridIntersection: ceilingGridIntersection,
    };
  }
);
